module.exports = __webpack_public_path__ + "europa-5_emerald_number.jpg?e531319dde066444fe8eecfdb507a4b2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/features/europa-5_emerald_number.jpg
// module id = 386
// module chunks = 0